import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import InvestorDeckV3 from "./pages/InvestorDeckV3";
import AccessGate from "./components/AccessGate";

function App() {
  return (
    <div className="App">
      <AccessGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<InvestorDeckV3 />} />
          </Routes>
        </BrowserRouter>
      </AccessGate>
    </div>
  );
}

export default App;
